module.exports = __webpack_public_path__ + "img/allowed_ai.3e68df98.png";